export const GENERIC_CURP = 'XXXX999999XXXXXX99';
